import { Cookies } from 'react-cookie';

import { ApiResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getDataToCreateEnc = async (objectSlug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.get<ApiResponse>(`/encounters/${objectSlug}/get-create-data/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as ApiResponse;
};
